import { t } from "i18next";
import { lazy } from "react";
import { getRoute } from "util/react";

export const ClientProfileRoute = getRoute(
  { title: t("profile"), fullPath: "/:locale?/client/profile/details" },
  "details",
  lazy(() => import("./profile")),
  null,
);

export const ClientProfileCompanyRoute = getRoute(
  { title: t("company_info"), fullPath: "/:locale?/client/profile/company" },
  "company",
  lazy(() => import("./company")),
  null,
);

export const ClientProfileSettings = getRoute(
  { fullPath: "/:locale?/client/profile" },
  "client/profile",
  lazy(() => import("pages/profile/settings")),
  [ClientProfileRoute, ClientProfileCompanyRoute],
);

export const ClientBidsRoute = getRoute(
  { fullPath: "/:locale?/client/orders/:id/bids" },
  "client/orders/:id/bids",
  lazy(() => import("./bids")),
  null,
);

export const ClientBidDetailsRoute = getRoute(
  { fullPath: "/:locale?/client/orders/:id/bids/:bidId" },
  "client/orders/:id/bids/:bidId",
  lazy(() => import("./bidDetails")),
  null,
);

export const ClientActiveOrdersRoute = getRoute(
  { fullPath: "/:locale?/client/active-orders" },
  "client/active-orders",
  lazy(() => import("./activeOrders")),
  null,
);

export const ClientArchiveRoute = getRoute(
  { fullPath: "/:locale?/client/archive" },
  "client/archive",
  lazy(() => import("./archive")),
  null,
);

export const ClientNewOrdersRoute = getRoute(
  { fullPath: "/:locale?/client/new-orders" },
  "client/new-orders",
  lazy(() => import("./newOrders")),
  null,
);

export const ClientReviewsRoute = getRoute(
  { fullPath: "/:locale?/client/reviews/:clientId" },
  "client/reviews/:clientId",
  lazy(() => import("./reviews")),
  null,
);

export const ClientCreateReviewRoute = getRoute(
  { fullPath: "/:locale?/client/create-review/:id/:to" },
  "client/create-review/:id/:to",
  lazy(() => import("./createReview")),
  null,
);

const ClientRoute = (
  <>
    {ClientNewOrdersRoute}
    {ClientBidsRoute}
    {ClientProfileSettings}
    {ClientActiveOrdersRoute}
    {ClientArchiveRoute}
    {ClientReviewsRoute}
    {ClientCreateReviewRoute}
    {ClientBidDetailsRoute}
  </>
);

export default ClientRoute;
